import { AuthProvider } from './Auth'

export const AppAuthProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <AuthProvider>{children}</AuthProvider>
}
